import SceneProperties from '../data/SceneProperties';
import ActionModel from './ActionModel';
import PlatformType from './PlatformTypeModel';

class PlatformModel {
    bottom: number;
    left: number;
    height: number;
    width: number;
    type: number;
    action: any;
    isHoriz: boolean;
    coverup:boolean;

    constructor(bottom: number, left: number, height: number, width: number, action:(ActionModel | null) = null, isHoriz = true, coverup = false) {
        this.bottom = bottom / 100 * window.innerHeight;
        this.left = left / 100 * document.body.clientWidth * SceneProperties.totalWidthFact;
        this.width = width / 100 * document.body.clientWidth * SceneProperties.totalWidthFact;
        this.height = height / 100 * window.innerHeight;
        this.isHoriz = isHoriz;
        this.coverup = coverup;

        //for moving platforms
        this.type = (action == null) ? PlatformType.NORMAL : PlatformType.MOVING;
        this.action = action;
    }
}

export default PlatformModel;